import React from 'react'
import { StudentIframePage } from '../Common/StudentIframePage'

const StudentFinancialAid = () => {
	return <StudentIframePage activeMenu="Financial Aid" pageName="FinancialAid" linkField="finaidlink" title="Financial Aid" />
}

export { StudentFinancialAid }
